import { z } from 'zod';
import { AuthorKind, Visibility } from './enums.js';
/** One user's emoji reaction on a comment (flat; the UI aggregates counts). */
export const MessageReaction = z.object({
    emoji: z.string(),
    userId: z.string(),
    userName: z.string().nullable(),
});
/** Full internal message projection. */
export const Message = z.object({
    id: z.string(),
    ticketId: z.string(),
    body: z.string(),
    authorKind: AuthorKind,
    authorId: z.string().nullable(),
    authorName: z.string().nullable(),
    visibility: Visibility,
    externalId: z.string().nullable(),
    deliveryStatus: z.string().nullable(), // pending | delivered | failed | n/a
    /** Parent comment id when this message is a threaded reply. */
    parentMessageId: z.string().nullable(),
    reactions: z.array(MessageReaction),
    editedAt: z.string().nullable(),
    createdAt: z.string(),
});
/** Customer-safe message projection — only customer_visible content. */
export const CustomerSafeMessage = z.object({
    id: z.string(),
    body: z.string(),
    authorKind: z.enum(['internal_user', 'customer_contact', 'system']),
    authorName: z.string().nullable(),
    createdAt: z.string(),
});
export const CreateMessageInput = z.object({
    body: z.string().min(1),
    visibility: Visibility.optional(),
    authorKind: AuthorKind.optional(),
    /** External message id for idempotent ingestion (FR-202). */
    externalId: z.string().optional(),
    /** Reply threading: id of the comment being replied to. */
    parentMessageId: z.string().optional(),
});
/** Toggle an emoji reaction on a comment (add if absent, remove if present). */
export const ToggleReactionInput = z.object({
    emoji: z.string().min(1).max(32),
});
/** Legacy intake message POST — visibility is forced to customer_visible. */
export const IntakeMessageInput = z.object({
    body: z.string().min(1),
    authorName: z.string().optional(),
    externalId: z.string().optional(),
});
//# sourceMappingURL=message.js.map